<template>
    <div class="modal__container">
        <div :class="classModal">
            <div class="modal__filter_header">
                <div class="modal__filter_header_text">
                    {{ headerTitle }}
                </div>
                <button class="modal__filter_header_close" @click.prevent="closeModal">
                    <svg>
                        <use xlink:href="/icons/base.svg#close"></use>
                    </svg>
                </button>
            </div>
            <div v-if="isOperationProduct" class="modal__filter_product">
                <div class="modal__filter_product_info">
                    <div v-if="isOperationProduct" class="modal__filter_product_info_img">
                        <picture>
                            <source :srcset="imageWebp" type="image/webp">
                            <source :srcset="imagePng" type="image/png">
                            <img :src="imagePng">
                        </picture>
                    </div>
                    <span class="modal__filter_product_info_title">{{ productTitle }}</span>
                </div>
                <div class="modal__filter_product_switch">
                    <switch_block
                        :key="'switch_block_'"
                        :switchStatus="switchStatus"
                        :width="52"
                        :height="32"
                        @click_switch="clickSwitch"
                    />
                </div>
            </div>
            <div v-else class="modal__filter_text_address">
                {{ headerText }}
            </div>
            <div class="modal__filter_list">
                <div class="modal__filter_list_container">
                    <modal_filter_item
                        v-for="(item, index) in filterList"
                        :key="'modal_filter_item_'+ index"
                        :filterItem="item"
                        :nameOperation="nameOperation"
                        @click_check="clickCheck"
                    />
                </div>
            </div>
            <div class="modal__filter_buttons">
                <div class="modal__filter_buttons_container">
                    <button class="modal__filter_buttons_clear" @click.prevent="clickClear">
                        <spinner_button
                            v-if="isDisableStop"
                            :key="'spinner_button_offline_list'"
                            :color="colorSpinnerIsDisabled"
                            :size="'30px'"
                        />
                        <div v-else class="modal__filter_buttons_clear_text">
                            {{ textButtonClear }}
                        </div>
                    </button>
                    <button v-if="!isOperationProduct" class="modal__filter_buttons_save" @click.prevent="clickSave">
                        <div class="modal__filter_buttons_save_text">
                            {{ textButtonSave }}
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import modal_filter_item from "./ModalFilterItem.vue";
import switch_block from "../../rest/SwitchBlock.vue";
import spinner_button from "../../loader/SpinnerButton.vue";
import {colorFunctions} from "../../../mixins/colorFunctions";
import {touchEvent} from "../../../mixins/touchEvent";

export default {
    name: "modal",
    props: {
        filterList: {
            type: Array,
            required: true,
            default: []
        },
        nameOperation: {
            type: String,
            required: true,
            default: ''
        },
        productSelect: {
            type: Object,
            required: false,
            default: null,
        }
    },
    mixins: [colorFunctions, touchEvent],
    emits: ['close', 'apply', 'remove_select_product'],
    components: {
        spinner_button,
        switch_block,
        modal_filter_item
    },
    data() {
        return {
            switchStatus: false,
            isDisableStop: false,
        }
    },
    beforeMount() {
        EventBus.$on('stop_list_action', this.stopListAction);
        EventBus.$on('error_data', this.errorData);
    },
    beforeUnmount() {
        EventBus.$off('stop_list_action', this.stopListAction);
        EventBus.$on('error_data', this.errorData);
    },
    methods: {
        touchStartEvent(){
            if(this.touchElementClass === 'modal__container') {
                setTimeout(() => {
                    this.closeModal();
                }, 200);
            }
        },
        stopListAction() {
            this.$emit('remove_select_product', this.filterList);
            this.isDisableStop = false;
            this.$emit('close');
        },
        errorData() {
            if (this.isOperationProduct) {
                this.isDisableStop = false;
            }
        },
        closeModal() {
            if (this.nameOperation === 'modal_filter') {
                this.filterList.forEach(item => item.isCheck = this.isCheckSave);
            } else if (this.nameOperation === 'modal_product_locations') {
                this.filterList.forEach(item => item.isCheckProductStopList = false);
            }
            this.$emit('close');
        },
        clickCheck(checkItem) {
            if (this.nameOperation === 'modal_filter') {
                checkItem.isCheck = !checkItem.isCheck;
            } else if (this.nameOperation === 'modal_product_locations') {
                checkItem.isCheckProductStopList = !checkItem.isCheckProductStopList;
            }
        },
        clickClear() {
            if (this.isOperationProduct) {
                this.disableStop();
                return;
            }
            this.filterList.forEach(item => item.isCheck = false);
        },
        disableStop() {
            this.isDisableStop = true;
            const params = {
                selectLocations: this.filterList.filter(item => item.isCheckProductStopList),
                productSelect: this.productSelect,
                action: 'remove',
                actionName: 'disableStop'
            }
            this.$store.dispatch('aggregators/STOP_LIST_ACTION', params);
        },
        clickSave() {
            this.filterList.forEach(item => {
                item.isCheckSave = item.isCheck;
            });
            this.$emit('apply');
        },
        clickSwitch() {
            this.switchStatus = !this.switchStatus;
            if (this.nameOperation === 'modal_filter') {
                this.filterList.forEach(item => item.isCheck = this.switchStatus)
            } else if (this.nameOperation === 'modal_product_locations') {
                this.filterList.forEach(item => item.isCheckProductStopList = this.switchStatus)
            }
        }
    },
    computed: {
        headerTitle() {
            if (this.nameOperation === 'modal_filter') {
                return `${this.__t('O.FILTERS')}`;
            }
            return `${this.__t('O.LOCATIONS_PRODUCT')}`;
        },
        headerText() {
            return `${this.__t('O.ADDRESS_ESTABLISHMENTS')}` + ' (' + this.filterList.length + ')';
        },
        classModal() {
            if (this.nameOperation === 'modal_product_locations') {
                return {
                    'modal__filter': true,
                    'product_menu': true,
                }
            }
            return {
                'modal__filter': true,
                'product_menu': false,
            }
        },
        textButtonClear() {
            if (this.nameOperation === 'modal_filter') {
                return `${this.__t('O.CLEAR_ALL')}`
            }
            return `${this.__t('O.REMOVE_FROM_STOP')}`
        },
        textButtonSave() {
            return `${this.__t('O.SAVE')}`
        },
        isOperationProduct() {
            return this.nameOperation === 'modal_product_locations';
        },
        imageWebp() {
            if (this.productSelect.image && this.productSelect.image.webp) {
                return this.productSelect.image.webp;
            }
            return '';
        },
        imagePng() {
            if (this.productSelect.image && this.productSelect.image.png) {
                return this.productSelect.image.png;
            }
            return '';
        },
        productTitle() {
            if (this.getObjectPathProperty(this.productSelect, 'product.title')) {
                return this.productSelect.product.title;
            }
            return `${this.__t('O.NO_TITLE')}`
        },
        colorSpinnerIsDisabled() {
            return this.darkerColorHex('#F6673C', 10);
        },

    },
    watch: {}
}
</script>
